import React, { useContext, useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Col, Form, Row, DropdownButton, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Dropdown } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceCart = (props) => {

    const { cart, setCart, selectedCurrency, cartItem, setJournalVoucher, idRow } = props;

    const { api, userData, settingData, accountData, warehouseData, selectedCompany,
        salableOptions, loadSalableOptions, refData, branchData, projectData, currencyData, rateFromToCurrency } = useContext(DataContext);

    const { openAddProductModal } = useContext(DynamicModalContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [spinning, setSpinning] = React.useState(false);
    const [scannedBarcode, setScannedBarcode] = useState("");

    useEffect(() => {
        if (!idRow) {
            setCart([cartItem])
            setJournalVoucher((prev) => ({
                ...prev,
                discountAmount: 0,
                discountPercentage: 0,
            }));
        }
    }, [selectedCurrency]);




    // Add new row
    const handleAddRow = () => {
        setCart((prevCart) => [...prevCart, cartItem]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event, type) => {
        event.preventDefault()

        if (cart.length > 1) {
            const updatedRows = cart.slice(0, -1);
            setCart(updatedRows);
        } else {
            toast.error('you need at least one item')
        }
    };

    const handleDeleteRowIndex = (index) => {
        const updatedRows = cart.filter((_, i) => i !== index);
        setCart(updatedRows);

    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedCart = [...cart];

        if (field == 'product') {
            updatedCart[index].productId = value.id;
            updatedCart[index].price = rateFromToCurrency(value.currency, selectedCurrency, value.price);
            updatedCart[index].cost = rateFromToCurrency(value.currency, selectedCurrency, value.cost);
            updatedCart[index].units = value.units;
            updatedCart[index].unitQuantity = 1;
            updatedCart[index].quantity = 1;
            updatedCart[index].type = value.type;
            updatedCart[index].index = index;
            updatedCart[index].isStock = value.isStock;
            updatedCart[index].vatPercentage = value.vat;

            if (value.type == 'simple' || value.type == 'serialized') {
                updatedCart[index].accountId = settingData.salesOfGoodsAccountId;
            }
            else if (value.type == 'service') {
                updatedCart[index].accountId = settingData.salesOfServiceAccountId;
            }
            else if (value.type == 'rawMaterial') {
                updatedCart[index].accountId = settingData.salesOfRawMaterialAccountId;
            }
            else if (value.type == 'production') {
                updatedCart[index].accountId = settingData.salesOfFinishedProductsAccountId;
            }
        }
        else if (field == 'price') {
            updatedCart[index].price = parseFloat(value);
        }
        else if (field == 'cost') {
            updatedCart[index].cost = parseFloat(value);
        }
        else if (field == 'quantity') {
            updatedCart[index].quantity = value;

        } else if (field == 'unitQuantity') {
            updatedCart[index].unitQuantity = value.quantity;
            updatedCart[index].unitName = value.name;

        }
        else if (field == 'details') {
            updatedCart[index].details = value;

        }
        else if (field == 'priceDiscountAmount') {
            updatedCart[index].priceDiscountAmount = value;
            updatedCart[index].priceDiscountPercentage = (updatedCart[index].priceDiscountAmount / (updatedCart[index].price * updatedCart[index].quantity)) * 100;

        }
        else if (field == 'priceDiscountPercentage') {
            updatedCart[index].priceDiscountPercentage = value;
        }
        else if (field == 'vatPercentage') {
            updatedCart[index].vatPercentage = value;
        }

        updatedCart[index].subQuantity = updatedCart[index].quantity * updatedCart[index].unitQuantity;
        updatedCart[index].netQuantity = parseFloat(updatedCart[index].subQuantity);

        updatedCart[index].priceDiscountAmount = (updatedCart[index].priceDiscountPercentage / 100) * (updatedCart[index].price * updatedCart[index].subQuantity);

        // TOTAL price

        const subPrice = (updatedCart[index].price * updatedCart[index].subQuantity);

        const totalPrice = subPrice - updatedCart[index].priceDiscountAmount;
        updatedCart[index].vatAmount = (updatedCart[index].vatPercentage / 100) * (totalPrice);
        updatedCart[index].netPrice = updatedCart[index].price;
        updatedCart[index].totalPrice = totalPrice;
        updatedCart[index].totalCost = updatedCart[index].cost * updatedCart[index].netQuantity;
        updatedCart[index].netCost = updatedCart[index].cost;

        setCart(updatedCart);
    }


    const handleBarcodeScan = (e) => {
        const barcode = e.target?.value;
        const product = salableOptions?.find(option => option.barcode === barcode);

        if (!product) {
            toast.error('Product not found');
            setScannedBarcode('');
            return;
        }

        setCart((prevCart) => {
            let updatedCart = [...prevCart];
            const existingProductIndex = updatedCart.findIndex(option => option.productId === product.id);

            if (existingProductIndex > -1) {
                let quantity = parseFloat(updatedCart[existingProductIndex].quantity) + parseFloat(1);
                handleRowChange(existingProductIndex, quantity, 'quantity');
            } else {
                // Add new product row

                let accountId;

                if (product.type == 'simple' || product.type == 'serialized' || product.type == 'compound') {
                    accountId = settingData.salesOfGoodsAccountId;
                }
                else if (product.type == 'service') {
                    accountId = settingData.salesOfServiceAccountId;
                }
                else if (product.type == 'rawMaterial') {
                    accountId = settingData.salesOfRawMaterialAccountId;
                }
                else if (product.type == 'production') {
                    accountId = settingData.salesOfFinishedProductsAccountId;
                }

                const productItem = {
                    accountId: accountId,
                    productId: product.id,
                    price: parseFloat(product.price),
                    units: product.units,
                    type: product.type,
                    unitQuantity: 1,
                    unitName: '',
                    subQuantity: 1,
                    priceDiscountAmount: 0,
                    priceDiscountPercentage: 0,
                    netQuantity: 1,
                    netPrice: product.price,
                    cost: product.cost,
                    quantity: 1,
                    vatPercentage: product.vat,
                    vatAmount: (product.vat / 100) * (product.price),
                    totalPrice: parseFloat(product.price),
                };

                if (cart.length == 1 && !cart[0].productId) {
                    updatedCart = [productItem];
                } else {
                    updatedCart.push(productItem);
                }

            }

            return updatedCart;
        });

        setScannedBarcode('');
    };


    const items = useMemo(() =>
        [
            {
                label: 'Simple',
                key: '1',
                onClick: () => openAddProductModal('simple')
            },
            {
                label: 'Serialized',
                key: '2',
                onClick: () => openAddProductModal('serialized')
            }
        ]);

    return (

        <div>

            <Spin spinning={spinning} fullscreen />


            <Row >
                <Col md={2}>
                    <Form.Label style={{ display: "inline-block", marginRight: "10px" }}>
                        Select Products
                    </Form.Label>
                    <Dropdown menu={{ items }} trigger={['click']} overlayStyle={{ zIndex: 9999 }} transitionName="">
                        <a onClick={e => e.preventDefault()}>
                            <Space> <FaPlus style={{ marginTop: "-8px" }} size={15} /> </Space>
                        </a>
                    </Dropdown>
                </Col>


                <Col>
                    <Form.Label>Unit</Form.Label>
                </Col>

                <Col style={{ flex: 0.6 }}>
                    <Form.Label>Quantity</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Unit Cost</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Unit Price</Form.Label>
                </Col>

                <Col style={{ flex: 0.6 }}>
                    <Form.Label>Discount %</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Discount</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Total price</Form.Label>
                </Col>


                <Col style={{ flex: 0.6 }}>
                    <Form.Label>VAT %</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Details</Form.Label>
                </Col>

                <Col style={{ flex: 0.2 }}>
                    <Form.Label></Form.Label>
                </Col>

            </Row>



            {cart.map((row, index) => (


                <Row className="g-0 mb-1" key={index}>
                    <Col md={2}>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={loadSalableOptions}
                            defaultOptions={[]}
                            onChange={(e) => handleRowChange(index, e, 'product')}
                            value={salableOptions?.find(option => option.value === cart[index].productId) || []}
                            noOptionsMessage={() => 'type to view'}
                            required
                        />
                    </Col>

                    {/* Units  Quantity*/}
                    <Col>
                        <Select
                            options={[
                                {
                                    value: { name: "", quantity: 1 },
                                    label: `(x1)`
                                },
                                ...(cart[index]?.units?.map(unit => ({
                                    value: { name: unit.name, quantity: unit.quantity },
                                    label: `${unit.name} (x${unit.quantity})`
                                })) || [])
                            ]}
                            onChange={(e) => handleRowChange(index, e.value, 'unitQuantity')}
                            defaultValue={{
                                value: JSON.stringify({ name: cart[index]?.unitName, quantity: cart[index]?.unitQuantity }),
                                label: `${cart[index]?.unitName} (x${cart[index]?.unitQuantity || 1})`
                            }}
                            className="react-select-sm"
                        />

                    </Col>

                    {/*  Quantity  */}
                    <Col style={{ flex: 0.6 }}>
                        <Form.Control type="number" min={0} step='any'
                            onChange={(e) => handleRowChange(index, e.target.value, 'quantity')}
                            style={{ backgroundColor: '#f0f8ff' }}
                            value={cart[index].quantity}
                            required
                        />
                    </Col>

                    {/* cost */}
                    <Col>
                        <Form.Control type="number" min={0} step='any' value={cart[index].cost}
                            style={{ backgroundColor: '#f7e8e8' }}
                            onChange={(e) => handleRowChange(index, e.target.value, 'cost')}
                            disabled={true}
                            required
                        />
                    </Col>

                    {/* price */}
                    <Col>
                        <Form.Control type="number" min={0} step='any' value={cart[index].price}
                            style={{ backgroundColor: '#f7e8e8' }}
                            onChange={(e) => handleRowChange(index, e.target.value, 'price')}
                            required
                        />
                    </Col>

                    {/* discount % */}
                    <Col style={{ flex: 0.6 }}>
                        <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].priceDiscountPercentage}
                            onChange={(e) => handleRowChange(index, e.target.value, 'priceDiscountPercentage')}
                            required
                        />
                    </Col>



                    {/* discount amount */}
                    <Col>
                        <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].priceDiscountAmount}
                            onChange={(e) => handleRowChange(index, e.target.value, 'priceDiscountAmount')}
                            required
                        />
                    </Col>


                    {/* final price */}
                    <Col>
                        <Form.Control type="number" name="total" id="total"
                            value={cart[index].totalPrice}
                            disabled />
                    </Col>


                    {/* VAT % */}
                    <Col style={{ flex: 0.6 }}>
                        <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].vatPercentage}
                            onChange={(e) => handleRowChange(index, e.target.value, 'vatPercentage')}
                            required
                        />
                    </Col>


                    {/* Details */}
                    <Col>
                        <Form.Control as="textarea" rows={1}
                            value={cart[index].details}
                            onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                        />
                    </Col>


                    <Col className="d-flex justify-content-end" style={{ flex: 0.2 }}>
                        <BiSolidTrash size={18} onClick={e => handleDeleteRowIndex(index)}
                            style={{ cursor: 'pointer', color: '#e6434f', marginTop: '10px' }} />
                    </Col>

                </Row>




            ))}





            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('cart')} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'cart')} />

                </Col>

            </Row>

            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <InputGroup style={{ backgroundColor: '#f0f8ff', width: '20%' }}>
                        <Form.Control type="text" placeholder='scan barcode to add ..'
                            value={scannedBarcode} onChange={e => setScannedBarcode(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') { handleBarcodeScan(e); } }} />
                        <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>

        </div>

    )
}


export default InvoiceCart;